export function MeteorIcon({ size = 24, color = "currentColor", strokeWidth = 17 }: { size?: number; color?: string; strokeWidth?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 592 592"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M117 192L207 100" />
        <path d="M166 214L324 58" />
        <path d="M191 264L282 170" />
        <path d="M109 408L201 317" />
        <path d="M157 462L316 304" />
        <path d="M181 481L275 389" />
        <path d="M318 407L410 315" />
        <path d="M364 455L523 276" />
        <path d="M389 481L483 389" />
        <path d="M233 77L245 65" />
        <path d="M305 151L317 139" />
        <path d="M225 292L237 280" />
        <path d="M296 366L308 354" />
        <path d="M502 366L514 354" />
        <circle cx="100" cy="282" r="54" />
        <circle cx="92" cy="499" r="54" />
        <circle cx="300" cy="499" r="54" />
        <circle cx="76" cy="282" r="8" fill={color} stroke="none" />
        <circle cx="68" cy="499" r="8" fill={color} stroke="none" />
        <circle cx="276" cy="499" r="8" fill={color} stroke="none" />
      </g>
    </svg>
  );
}
